module.exports = __webpack_public_path__ + "static/media/appointment.10311750.svg";